var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import admin_users_model from "@iscr/models/admin_users_model";
import user_model from "@iscr/models/user_model";
import { DefaultActionsColumn } from "./DefaultActionsColumn";
import { FullDataColumn } from "./FullDataColumn";
import { MfaColumn } from "./MfaColumn";
import { toastMessage } from "@iscr/xAppLib/helpers/toast_message";
import obj_diff from "@iscr/xAppLib/helpers/obj_diff";
import trim_object_spaces from "@iscr/xAppLib/helpers/trim_object_spaces";
import admin_users_model_base from "@iscr/models/admin_users_model_base";
import { ContactUs } from "@iscr/xAppLib/UIelems/ContactUs";
export const newAdminUsersUIEnabled = () => !!app.dev_env;
export function buildShowFields() {
    var _a, _b, _c, _d;
    let show_fields;
    if (((_b = (_a = app.user) === null || _a === void 0 ? void 0 : _a.claims) === null || _b === void 0 ? void 0 : _b.admin) || ((_d = (_c = app.user) === null || _c === void 0 ? void 0 : _c.claims) === null || _d === void 0 ? void 0 : _d.supp))
        show_fields = admin_users_model.LIST_DET_FIELDS_ADM;
    else if (app.acl.is_doc_admin)
        show_fields = admin_users_model.LIST_DET_FIELDS_DOC;
    else if (app.acl.is_tenant_manager)
        show_fields = admin_users_model.LIST_DET_FIELDS_TENANT_MANG;
    else
        show_fields = admin_users_model.LIST_DET_FIELDS_MANG;
    show_fields = show_fields.filter((field) => {
        var _a, _b, _c, _d;
        if (field.cust_fld === "set_booking_types")
            return (_b = (_a = app === null || app === void 0 ? void 0 : app.site_status) === null || _a === void 0 ? void 0 : _a.booking) === null || _b === void 0 ? void 0 : _b.show_admin_user_booking_types;
        if (field.name === "Booking")
            return app.acl.is_mang_cosm && ((_d = (_c = app === null || app === void 0 ? void 0 : app.site_status) === null || _c === void 0 ? void 0 : _c.booking) === null || _d === void 0 ? void 0 : _d.show_org_booking_menu);
        return true;
    });
    const hasRowNum = show_fields.some((f) => f.id === "row_number");
    const hasActions = show_fields.some((f) => f.id === "actions");
    return [
        !hasRowNum && {
            id: "row_number",
            name: "No",
            template: ({ row_num }) => _jsx(_Fragment, { children: row_num }),
        },
        ...show_fields,
        ...(user_model.check_access("cust_supp")
            ? [
                { name: "Full data", template: FullDataColumn },
                { name: "MFA", template: MfaColumn },
            ]
            : []),
        !hasActions && { name: "Actions", template: DefaultActionsColumn },
    ]
        .filter(Boolean)
        .filter((f) => f.show !== false);
}
export const toastErrorMessage = ({ action, message }) => toastMessage(_jsxs("div", { className: "space-y-2", children: [_jsxs("div", { className: "font-bold", children: ["There was a problem: ", action] }), _jsx("div", { children: message !== null && message !== void 0 ? message : (_jsxs(_Fragment, { children: ["Please try again, or ", _jsx(ContactUs, { className: "font-bold underline", children: "contact support" }), "."] })) })] }), "error", {
    className: "sm:min-w-96",
    autoClose: false,
    closeOnClick: false,
});
export const updateUserProfile = (user, update) => __awaiter(void 0, void 0, void 0, function* () {
    const prof_diff = obj_diff(user, trim_object_spaces(update));
    if (!prof_diff.to || !Object.keys(prof_diff.to).length)
        return;
    const params = { uid: user.uid, prof_diff };
    if (prof_diff.to.first_name || prof_diff.to.last_name) {
        params.newname =
            (prof_diff.to.first_name || user.first_name) + " " + (prof_diff.to.last_name || user.last_name);
    }
    return yield admin_users_model_base.upd_user_prof(params);
});
